import { Chip as MuiChip, ChipProps as MuiChipProps } from '@mui/material';

export const Chip = ({ ...rest }: MuiChipProps) => <MuiChip {...rest} />;
